import { useEffect, useState } from 'react';

import { api } from '../../../services';
import { stringify } from '../../../utils';
import { DADOS_INICIAIS } from './constantes';

function useIndicadoresFiscais(periodo) {
  const [dados, setDados] = useState(DADOS_INICIAIS);

  useEffect(() => {
    async function buscarDados() {
      const response = await api.get(
        `/indicadores_fiscais?${stringify({
          periodo: JSON.stringify(periodo),
        })}`,
      );

      setDados(response.data);
    }

    buscarDados();
  }, [periodo]);

  return dados;
}

export default useIndicadoresFiscais;
